import { styled } from "@pigment-css/react";
import type { Sentiment } from "@acto/genui-components-schema";

// Color-only concern: typography and the neutral color are inherited from the
// surrounding text component, so every card keeps its own type scale.
export const SentimentColor = styled("span")<{ sentiment: Sentiment }>(({ theme }) => ({
  variants: [
    {
      props: { sentiment: "positive" },
      style: { color: theme.fieldSalesTwo.colors.status.success.main },
    },
    {
      props: { sentiment: "negative" },
      style: { color: theme.fieldSalesTwo.colors.status.error.main },
    },
  ],
}));
